import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const AiSparkle16 = ({ height = 16, width = 16, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M7.76286 1.10456C7.81773 0.849065 8.18227 0.849065 8.23714 1.10456L8.88752 4.13328C9.20807 5.62607 10.3742 6.79217 11.867 7.11273L14.8957 7.76311C15.1512 7.81797 15.1512 8.18252 14.8957 8.23738L11.867 8.88776C10.3742 9.20832 9.20807 10.3744 8.88752 11.8672L8.23714 14.8959C8.18227 15.1514 7.81773 15.1514 7.76286 14.8959L7.11248 11.8672C6.79193 10.3744 5.62583 9.20832 4.13304 8.88776L1.10432 8.23738C0.848821 8.18252 0.848821 7.81797 1.10432 7.76311L4.13304 7.11273C5.62583 6.79217 6.79193 5.62607 7.11248 4.13328L7.76286 1.10456Z"
      fill="url(#paint0_linear_125_75000)"
      strokeWidth="0"
    />
    <defs>
      <linearGradient
        id="paint0_linear_125_75000"
        x1="14.2503"
        y1="0.000244477"
        x2="1.74972"
        y2="16.0002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4D80" />
        <stop offset="0.0667" stopColor="#FE4D81" />
        <stop offset="0.1333" stopColor="#FC4E82" />
        <stop offset="0.2" stopColor="#F95086" />
        <stop offset="0.2667" stopColor="#F4528A" />
        <stop offset="0.3333" stopColor="#EE5490" />
        <stop offset="0.4" stopColor="#E65897" />
        <stop offset="0.4667" stopColor="#DE5B9F" />
        <stop offset="0.5333" stopColor="#D65FA7" />
        <stop offset="0.6" stopColor="#CE62AF" />
        <stop offset="0.6667" stopColor="#C666B6" />
        <stop offset="0.7333" stopColor="#C068BC" />
        <stop offset="0.8" stopColor="#BB6AC0" />
        <stop offset="0.8667" stopColor="#B86CC4" />
        <stop offset="0.9333" stopColor="#B66DC5" />
        <stop offset="1" stopColor="#B56DC6" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
